// extracted by mini-css-extract-plugin
export default {"dialog":"uploadStatus_dialog__7Fty0","progress":"uploadStatus_progress__FD2sG"};